/**
 * AddCategoryCtrl controller
 * Add/edit categories
 */

/**
 * AddCategoryCtrl controller
 *
 * @class AddNumberGroupCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddNumberGroupCtrl
 */
/* @ngInject */
export default function AddChannelGroupCtrl ($uibModalInstance, overlay, cl, isNew) {
  var vm = this
  vm.overlay = overlay

  vm.isNew = isNew

  var segments = []
  for (var i = cl.groups.length; i--;) {
    if (cl.groups[i] !== overlay) {
      segments.push([
        cl.groups[i].fromNumber,
        cl.groups[i].toNumber
      ])
    }
  }
  vm.segments = segments

  vm.ok = function () {
    $uibModalInstance.close(overlay)
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
